module.exports = __webpack_public_path__ + "static/img/witness-kids-2.f9f3a212.png";